import http from "@/api/request";
import { BENEFIT_OPS_MEMBERS_BASE } from "@/config/apiBaseUrlConfig";

import type { MarketingAchievementMemberRowVO } from "./type";

export type * from "./type";

/**
 * 会员成就列表
 * GET /service-chijing-benefit/api/ops/benefit/members/{memberId}/achievements
 * @param memberId 会员 ID
 * @param shopId 门店 ID（必填）
 */
export const getMemberAchievements = (memberId: string, shopId: string) => {
  return http.get<MarketingAchievementMemberRowVO[]>(
    `${BENEFIT_OPS_MEMBERS_BASE}/${memberId}/achievements`,
    { params: { shopId } },
  );
};
